module.exports = require("@ethersproject/strings");